/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WalletPassTokenResponseDto } from '../models/WalletPassTokenResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class WalletPassService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Download Apple Wallet pass (.pkpass)
   * @returns any
   * @throws ApiError
   */
  public downloadApplePass({
    membershipId,
  }: {
    membershipId: number,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/association/{associationId}/membership/{membershipId}/apple',
      path: {
        'membershipId': membershipId,
      },
    });
  }
  /**
   * Get Google Wallet "Add to Wallet" link
   * @returns any
   * @throws ApiError
   */
  public getGoogleWalletLink({
    membershipId,
  }: {
    membershipId: number,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/association/{associationId}/membership/{membershipId}/google',
      path: {
        'membershipId': membershipId,
      },
    });
  }
  /**
   * Download Apple Wallet pass by serial number
   * @returns any
   * @throws ApiError
   */
  public downloadPassBySerial({
    serialNumber,
  }: {
    serialNumber: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/association/{associationId}/membership/{membershipId}/download/{serialNumber}',
      path: {
        'serialNumber': serialNumber,
      },
    });
  }
  /**
   * Generate one-time token for wallet pass download
   * Returns a single token that works for both Apple and Google Wallet
   * @returns WalletPassTokenResponseDto
   * @throws ApiError
   */
  public generateWalletPassToken({
    membershipId,
  }: {
    membershipId: number,
  }): CancelablePromise<WalletPassTokenResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/association/{associationId}/membership/{membershipId}/wallet-pass-link',
      path: {
        'membershipId': membershipId,
      },
    });
  }
}
